import {CommonStatus} from "@/enums/status";

export class SaleParams {
    page? = 1;
    limit? = 20;
    search?: string;
    status?: CommonStatus;
    fromDate?: number;
    toDate?: number;
    provinceId?: number;
    districtId?: number;
    createdByRowGuid?: string;
    employeeRowGuid?: string;
}
